export enum Breakpoint {
  Small = 576,
  Medium = 768,
  Large = 992,
  XLarge = 1200,
  XXLarge = 1400,
}
